import { defineMessages } from "react-intl";

const messages = defineMessages({
  requiredQuestions: {
    id: "candidate.taking.requiredQuestions",
    defaultMessage: "Please respond to all required questions.",
  },
  noLongerAvailable: {
    id: "candidate.registration.noLongerAvailable",
    defaultMessage:
      "Sorry, this is no longer available. If you think this is a mistake, please reach out to the hiring manager.",
  },
});

export const REQUIRED_QUESTIONS_MESSAGE = messages.requiredQuestions;
export const NO_LONGER_AVAILABLE_MESSAGE = messages.noLongerAvailable;
export const NO_LONGER_AVAILABLE_EN = messages.noLongerAvailable.defaultMessage;
